var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-s-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5858 33.7087C31.3668 34.4897 32.633 34.4896 33.414 33.7086L43.7853 23.3374C44.5665 22.5561 45.8332 22.5564 46.6142 23.3379L47.5574 24.2818C48.338 25.0629 48.3378 26.3289 47.5569 27.1097L33.4142 41.2525C32.6331 42.0335 31.3668 42.0335 30.5858 41.2525L16.4435 27.1102C15.6625 26.3292 15.6625 25.0628 16.4435 24.2818L17.3859 23.3394C18.1669 22.5584 19.4331 22.5583 20.2142 23.3393L30.5858 33.7087Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLine);
export default __webpack_public_path__ + "static/media/arrow-down-line.97cdd54b2698325fa3a40b8112ffb4fb.svg";
export { ForwardRef as ReactComponent };